import React from "react";
import { PostUser, User } from "../types";

type UsersContextType = {
  user: User | PostUser | null;
  setUser: (user: PostUser | null) => void;
  currentUser: User | null;
  setCurrentUser: (user: User | null) => void;
  userUsinasIds: string[];
  setUserUsinasIds: (usinas: string[]) => void;
};

const defaultValue: UsersContextType = {
  user: null,
  setUser: () => {},
  currentUser: null,
  setCurrentUser: () => {},
  userUsinasIds: [],
  setUserUsinasIds: () => {},
};

export const UsersContext = React.createContext(defaultValue);

export default function UsersContextProvider(props: {
  children: React.ReactNode;
}) {
  const [user, setUser] = React.useState<User | PostUser | null>(null);
  const [currentUser, setCurrentUser] = React.useState<User | null>(null);
  const [userUsinasIds, setUserUsinasIds] = React.useState<string[]>([]);

  return (
    <UsersContext.Provider
      value={{
        user,
        setUser,
        currentUser,
        setCurrentUser,
        userUsinasIds,
        setUserUsinasIds,
      }}
    >
      {props.children}
    </UsersContext.Provider>
  );
}
